import { render, staticRenderFns } from "./MaterialSimulationCardamom.vue?vue&type=template&id=b79ad228"
import script from "./MaterialSimulationCardamom.vue?vue&type=script&lang=js"
export * from "./MaterialSimulationCardamom.vue?vue&type=script&lang=js"
import style0 from "./MaterialSimulationCardamom.vue?vue&type=style&index=0&id=b79ad228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports